import { cn } from "@/libs/base/utils/layout";

interface ComponentProps {
  size?: number;
  className?: string;
}

export default function Spinner({ size, className }: ComponentProps) {
  size = (size || 5) * 0.25;

  return (
    <svg
      className={cn(className, "animate-spin")}
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: `${size}rem`,
        height: `${size}rem`,
      }}
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V2.392a10 10 0 00-7.416 17.416L5.17 15.17A7.96 7.96 0 014 12zm2 0a6 6 0 016-6V3.918a8.96 8.96 0 00-6.639 15.638L6.17 16.17A5.96 5.96 0 016 12z"
      ></path>
    </svg>
  );
}
